import * as seoSharedModule from './seoShared.common.js';

const seoShared = seoSharedModule.default || seoSharedModule;

const {
  SITE_URL,
  ORGANIZATION_SCHEMA,
  PARK_NAMES,
  PUBLIC_PARK_SLUG_ALIASES,
  INTERNAL_PARK_PUBLIC_SLUGS,
  LEGACY_ROUTE_REDIRECTS,
  STATIC_ROUTE_META,
  NOINDEX_PATH_PREFIXES,
  RESERVED_NON_PARK_SEGMENTS,
  PARK_GEO,
  PARK_ENTITY_DETAILS,
  POPULAR_PARKS_FOR_ITEMLIST,
  SEO_RELEASE_LASTMOD,
  SEO_ROUTE_LASTMOD,
  PARK_SEO_CONTENT,
  getParkSeoContent,
  getParkSeoFooterContent,
  buildSitemapEntries,
  normalizePath,
  getCanonicalPath,
  getInternalParkSlugForPublicSlug,
  getPublicParkSlug,
  getPublicParkPath,
  getRouteInfo,
  parseSitemapRoutes,
  collectSeoRoutePaths,
  shouldNoIndex,
  isIndexableParkSubpageRoute,
  isKnownSeoRoute,
  getStaticOgImageForPath,
  resolveOgImage,
  buildDynamicMeta,
  getSeoMetaForRoute,
  titleCaseFromSlug,
} = seoShared;

export {
  SITE_URL,
  ORGANIZATION_SCHEMA,
  PARK_NAMES,
  PUBLIC_PARK_SLUG_ALIASES,
  INTERNAL_PARK_PUBLIC_SLUGS,
  LEGACY_ROUTE_REDIRECTS,
  STATIC_ROUTE_META,
  NOINDEX_PATH_PREFIXES,
  RESERVED_NON_PARK_SEGMENTS,
  PARK_GEO,
  PARK_ENTITY_DETAILS,
  POPULAR_PARKS_FOR_ITEMLIST,
  SEO_RELEASE_LASTMOD,
  SEO_ROUTE_LASTMOD,
  PARK_SEO_CONTENT,
  getParkSeoContent,
  getParkSeoFooterContent,
  buildSitemapEntries,
  normalizePath,
  getCanonicalPath,
  getInternalParkSlugForPublicSlug,
  getPublicParkSlug,
  getPublicParkPath,
  getRouteInfo,
  parseSitemapRoutes,
  collectSeoRoutePaths,
  shouldNoIndex,
  isIndexableParkSubpageRoute,
  isKnownSeoRoute,
  getStaticOgImageForPath,
  resolveOgImage,
  buildDynamicMeta,
  getSeoMetaForRoute,
  titleCaseFromSlug,
};

export default seoShared;
